import { useContext, useState } from "react";
import { AuthContext } from "../../../AuthContext/AuthContext";
import { IPage9 } from "../../../Interfaces/cadernos/caderno9";
import { Button, Modal, Stack, TextField } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { loader } from "../../../Func_genericas/loader";
import { cores } from "../../../Func_genericas/valores_estaticos";
import { CustomSelect, CustomTextFieldletrapequena } from "../../../Styles/theme/customThemeprovider";
import { unidade_medida_Kg_l_t, unidade_medida_Kw } from "../../../informacao_estatica";
import DeleteIcon from "@mui/icons-material/Delete";
import { BarraDeFerramentas } from "../../../Components/barra-de-ferramentas/BarraDeFerramentas";
import { post } from "../../../Services/tokenConfig";
import { func_print } from "../../../Func_genericas/func_print";

interface I_aux {
    lista_artigos: IPage9[],
    flag_open_modal: boolean,
    set_flag_open_modal: React.Dispatch<React.SetStateAction<boolean>>,
    setMessage: React.Dispatch<React.SetStateAction<string>>,
    setOpenSnackSuccess: React.Dispatch<React.SetStateAction<boolean>>,
    setOpenSnackError: React.Dispatch<React.SetStateAction<boolean>>,
    set_lista_artigos: React.Dispatch<React.SetStateAction<IPage9[]>>,
    setRows: React.Dispatch<React.SetStateAction<IPage9[]>>,
    setRows_filtrada: React.Dispatch<React.SetStateAction<IPage9[]>>,

}

type IPage9Errors = Partial<Record<keyof IPage9, boolean>>;

export const ModalValidarDadosFatura: React.FC<I_aux> = ({
    lista_artigos,
    flag_open_modal,
    set_flag_open_modal,
    setMessage,
    setOpenSnackSuccess,
    setOpenSnackError,
    set_lista_artigos,
    setRows,
    setRows_filtrada,
}) => {
    const auth = useContext(AuthContext);


    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [errosArtigos, setErrosArtigos] = useState<Record<number, IPage9Errors>>({});

    const camposNumericos: (keyof IPage9)[] = [
        "quantidade",
        "consumo_energetico",
    ];
    const converterParaNumero = (valor: any): number | "" => {
        if (valor === "" || valor === null || valor === undefined) {
            return "";
        }

        const texto = String(valor).trim();

        if (texto === "") {
            return "";
        }

        const valorNormalizado = texto
            .replace(/\./g, "") // remove pontos de milhares
            .replace(",", "."); // troca vírgula decimal por ponto

        const numero = Number(valorNormalizado);

        return Number.isNaN(numero) ? "" : numero;
    };
    const handleChangeProduto = <K extends keyof IPage9>(
        index: number,
        campo: K,
        valor: IPage9[K]
    ) => {
        let novoValor: any = valor;

        if (camposNumericos.includes(campo)) {
            const texto = String(valor);

            if (!/^[0-9.,]*$/.test(texto)) {
                return;
            }

            novoValor = texto;
        }

        set_lista_artigos((prev) =>
            prev.map((produto, i) =>
                i === index
                    ? {
                        ...produto,
                        [campo]: novoValor,
                    }
                    : produto
            )
        );

        setErrosArtigos((prev) => ({
            ...prev,
            [index]: {
                ...prev[index],
                [campo]: false,
            },
        }));
    };
    const handleDeleteProduto = (index: number) => {
        set_lista_artigos((prev) => prev.filter((_, i) => i !== index));
    };
    const handleSave = async () => {
        const valido = validarArtigos();

        if (!valido) {
            setMessage("Erro ao efetuar a sua operação, dados inválidos!");
            setOpenSnackError(true);
            return;
        }
        try {
            setIsLoading(true);

            let res = await post(auth.token.cookie_token, "new_reg_adquisicao_entrada_nove_bulk", {
                payload: lista_artigos
            });
            if (res.status === 200) {
                setMessage("Gravado com sucesso!");
                setOpenSnackSuccess(true);
                setRows((prev) => [...prev, ...res.data.result]);
                setRows_filtrada((prev) => [...prev, ...res.data.result]);
                set_flag_open_modal(false);

            } else {
                setMessage("Erro ao gravar!");
                setOpenSnackError(true);
            }
            setIsLoading(false);

        } catch (error) {
            func_print("handleSave", error, true);
            setMessage("Erro ao efetuar a sua operação!");
            setOpenSnackError(true);
            setIsLoading(false);
        }

    };
    const validarArtigos = () => {
        const novosErros: Record<number, IPage9Errors> = {};

        lista_artigos.forEach((item, index) => {
            novosErros[index] = {
                produto: !item.produto,
                fornecedor: !item.fornecedor,
                origem: !item.origem,
                destino: !item.destino,
                data: !item.data,
                quantidade: !item.quantidade,
                // medida: !item.medida,
                consumo_energetico: !item.consumo_energetico,
                // medida_energetico: !item.medida_energetico,
            };
        });

        setErrosArtigos(novosErros);

        const temErros = Object.values(novosErros).some((erros) =>
            Object.values(erros).some(Boolean)
        );

        return !temErros;
    };

    return (<Modal
        style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }}
        open={flag_open_modal}
    >
        <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            backgroundColor: 'white',
            width: '90%',
            height: '80%',
            flexDirection: 'column',
            borderRadius: 5,
        }}>
            <div style={{
                width: '100%',
                display: "flex",
                alignItems: 'space-between',
                justifyContent: 'flex-end',
                flex: 0.1,
            }}>

                <div
                    style={{
                        color: cores.cor1,
                        display: "flex",
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                        fontWeight: 'bold',
                        fontSize: 25,
                        paddingLeft: 10,
                        width: '100%',
                        fontFamily: "candara"
                    }}>

                    Lista de Artigos Registados na Fatura

                </div>
                <div style={{
                    width: '100%',
                    display: "flex",
                    alignItems: 'flex-start',
                    justifyContent: 'flex-end',
                }}>
                    <Button
                        sx={{ color: "#AAAAAA" }}
                        size="large"
                        onClick={() => {
                            set_flag_open_modal(false)
                        }}
                    >
                        <CloseIcon />
                    </Button>
                </div>
            </div>

            {
                isLoading === true ?
                    loader() :
                    <>


                        <div style={{
                            flex: 0.8,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'flex-start',
                            flexDirection: 'column',
                            width: '100%',
                            overflowY: 'scroll',
                            scrollbarWidth: 'thin',
                            height: '100%',
                            paddingBottom: 10
                        }}
                        >
                            <div
                                style={{
                                    width: "96%",
                                    display: "flex",
                                    flexDirection: "column",
                                    padding: 8,
                                }}
                            >
                                {lista_artigos.map((item, index) => (
                                    <div
                                        key={index}
                                        style={{
                                            border: "1px solid #ddd",
                                            borderRadius: 6,
                                            padding: 10,
                                            backgroundColor: "#fafafa",
                                            marginBottom: 12,
                                        }}
                                    >
                                        {/* Cabeçalho do artigo */}
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                // marginBottom: 4,
                                            }}
                                        >
                                            <div
                                                style={{
                                                    fontWeight: "bold",
                                                    color: cores.cor1,
                                                    fontFamily: "candara",
                                                    fontSize: 15,
                                                }}
                                            >
                                                Artigo {index + 1}

                                            </div>

                                            <Button
                                                size="small"
                                                onClick={() => handleDeleteProduto(index)}
                                                sx={{
                                                    minWidth: 0,
                                                    color: "#b00020",
                                                    padding: "4px",
                                                }}
                                            >
                                                <DeleteIcon fontSize="small" />
                                            </Button>
                                        </div>

                                        {/* Campos */}
                                        <div
                                            style={{
                                                display: 'flex',
                                                flexDirection: 'column',

                                            }}
                                        >

                                            <div style={{
                                                display: 'flex',
                                                flexDirection: 'row',
                                                gap: 8,

                                            }}>
                                                <CustomTextFieldletrapequena
                                                    size="small"
                                                    label="Produto"
                                                    name="produto"
                                                    value={item.produto || ""}
                                                    onChange={(e: any) =>
                                                        handleChangeProduto(index, "produto", e.target.value)
                                                    }
                                                    error={!!errosArtigos[index]?.produto}
                                                    helperText={errosArtigos[index]?.produto ? "Preencha este campo" : ""}
                                                // sx={{
                                                //     "& .MuiInputBase-root": {
                                                //     },
                                                //     "& .MuiInputBase-input": {
                                                //         fontSize: 11,
                                                //     },
                                                //     "& .MuiInputLabel-root": {
                                                //     },
                                                // }}
                                                // inputProps={{
                                                //     style: {
                                                //       fontSize: 11,
                                                //     },
                                                //   }}

                                                />

                                                <CustomTextFieldletrapequena
                                                    label="Fornecedor"
                                                    name="fornecedor"
                                                    size="small"
                                                    value={item.fornecedor || ""}
                                                    onChange={(e: any) =>
                                                        handleChangeProduto(index, "fornecedor", e.target.value)
                                                    }
                                                    error={!!errosArtigos[index]?.fornecedor}
                                                    helperText={errosArtigos[index]?.fornecedor ? "Preencha este campo" : ""}
                                                />
                                                <CustomTextFieldletrapequena
                                                    label="Origem"
                                                    name="origem"
                                                    size="small"
                                                    value={item.origem || ""}
                                                    onChange={(e: any) =>
                                                        handleChangeProduto(index, "origem", e.target.value)
                                                    }
                                                    error={!!errosArtigos[index]?.origem}
                                                    helperText={errosArtigos[index]?.origem ? "Preencha este campo" : ""}
                                                />

                                                <CustomTextFieldletrapequena
                                                    label="Destino"
                                                    name="destino"
                                                    size="small"
                                                    value={item.destino || ""}
                                                    onChange={(e: any) =>
                                                        handleChangeProduto(index, "destino", e.target.value)
                                                    }
                                                    error={!!errosArtigos[index]?.destino}
                                                    helperText={errosArtigos[index]?.destino ? "Preencha este campo" : ""}
                                                />
                                            </div>
                                            <div style={{
                                                display: 'flex',
                                                flexDirection: 'row',
                                                gap: 8,
                                                justifyContent: 'space-between',
                                                alignItems: 'center',



                                            }}>

                                                <CustomTextFieldletrapequena
                                                    label="Doc. Nº"
                                                    name="doc"
                                                    size="small"
                                                    value={item.doc || ""}
                                                    onChange={(e: any) =>
                                                        handleChangeProduto(index, "doc", e.target.value)
                                                    }
                                                    sx={{
                                                        display: 'flex',
                                                        flex: 0.25
                                                    }}
                                                />
                                                <TextField
                                                    label="Data"
                                                    type="date"
                                                    variant="filled"
                                                    size="small"
                                                    value={item.data || ""}
                                                    onChange={(e) =>
                                                        handleChangeProduto(index, "data", e.target.value)
                                                    }
                                                    sx={{
                                                        display: 'flex',
                                                        flex: 0.25
                                                    }}
                                                    error={!!errosArtigos[index]?.data}
                                                    helperText={errosArtigos[index]?.data ? "Preencha este campo" : ""}
                                                />

                                                <Stack direction="row" spacing={0.5} sx={{
                                                    display: 'flex',
                                                    flex: 0.25
                                                }}>
                                                    <CustomTextFieldletrapequena
                                                        label="Qtd."
                                                        name="quantidade"
                                                        size="small"
                                                        value={item.quantidade || ""}
                                                        onChange={(e: any) =>
                                                            handleChangeProduto(index, "quantidade", e.target.value)
                                                        }
                                                        sx={{
                                                            width: '80%',

                                                        }}
                                                        error={!!errosArtigos[index]?.quantidade}
                                                        helperText={
                                                            errosArtigos[index]?.quantidade ? "Insira apenas números" : ""
                                                        }
                                                    />

                                                    <CustomSelect
                                                        value={item.medida || ""}
                                                        name="medida"

                                                        onChange={(e: any) =>
                                                            handleChangeProduto(index, "medida", e.target.value)
                                                        }
                                                        options={unidade_medida_Kg_l_t}
                                                        label="UM"
                                                        minWidth={60}
                                                    />
                                                </Stack>




                                                <Stack direction="row" spacing={0.5} sx={{
                                                    display: 'flex',
                                                    flex: 0.25
                                                }}>
                                                    <CustomTextFieldletrapequena
                                                        label="Consumo"
                                                        name="consumo_energetico"
                                                        size="small"
                                                        value={item.consumo_energetico || ""}
                                                        onChange={(e: any) =>
                                                            handleChangeProduto(
                                                                index,
                                                                "consumo_energetico",
                                                                e.target.value
                                                            )
                                                        }
                                                        sx={{
                                                            width: '80%',
                                                        }}
                                                        error={!!errosArtigos[index]?.consumo_energetico}
                                                        helperText={
                                                            errosArtigos[index]?.consumo_energetico ? "Insira apenas números" : ""
                                                        }
                                                    />

                                                    <CustomSelect
                                                        value={item.medida_energetico || ""}
                                                        name="medida_energetico"
                                                        onChange={(e: any) =>
                                                            handleChangeProduto(index, "medida_energetico", e.target.value)
                                                        }
                                                        options={unidade_medida_Kw}
                                                        label="UM"
                                                        minWidth={60}
                                                    />
                                                </Stack>
                                            </div>

                                            <div style={{ gridColumn: "span 4" }}>
                                                <CustomTextFieldletrapequena
                                                    label="Observações"
                                                    size="small"
                                                    name="obs"
                                                    value={item.obs || ""}
                                                    onChange={(e: any) =>
                                                        handleChangeProduto(index, "obs", e.target.value)
                                                    }

                                                />
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>


                        </div>
                    </>
            }
            <div style={{
                flex: 0.1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                flexDirection: 'row',
                width: '90%',

            }}>
                <BarraDeFerramentas
                    mostrarBotaoGravar
                    // textoBotaoNovo="Novo Registo"
                    aoClicarGravar={() => {
                        handleSave()

                    }}
                />
            </div>
        </div>



    </Modal>)

}
